import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const TableIcon = (p: IconProps) => <Icon {...p}><path d="M3 5h18M3 9h18M3 14h18M3 19h18M8 5v14M16 5v14" /></Icon>
